/**
 * アラート設定の表示・動作制御設定
 */
export const ALERT_SETTINGS_CONFIG = {
  // === 監視アイテム関連 ===
  monitoring: {
    // 欠点率(本日分)の表示フラグ
    showDefectRateToday: false
  },

  // === 判定ルール関連 ===
  rules: {
    // 利用可能な判定ルールのリスト
    // 現在は3σ判定のみ、将来的に拡張可能
    available: [
      {
        value: '1',
        label: '3σ異常判定（最新結果と直近30日間の比較）',
        enabled: true
      }
      // 将来的に追加例：
      // {
      //   value: '2',
      //   label: '3σ異常判定（最新結果と直近30日間の比較）',
      //   enabled: false
      // }
    ]
  },

  // === 判定頻度関連 ===
  intervals: {
    // 利用可能な判定頻度のリスト
    available: [
      {value: '1', hours: 1, enabled: true},
      {value: '2', hours: 2, enabled: true},
      {value: '3', hours: 3, enabled: true},
      {value: '4', hours: 4, enabled: true},
      {value: '5', hours: 5, enabled: true},
      {value: '6', hours: 6, enabled: true},
      {value: '7', hours: 7, enabled: true},
      {value: '8', hours: 8, enabled: true},
      {value: '9', hours: 9, enabled: true},
      {value: '10', hours: 10, enabled: true},
      {value: '11', hours: 11, enabled: true},
      {value: '12', hours: 12, enabled: true}
    ]
  }
} as const;

/**
 * 監視アイテムの値定義
 */
export const MONITORING_ITEM_VALUES = {
  DEFECT_RATIO: '1', // 不良率（本日分）
  DEFECT_RATE: '2' // 欠点率（本日分）
} as const;

/**
 * ヘルパー関数：有効な判定頻度のリストを取得
 */
export const getAvailableIntervals = () => {
  return ALERT_SETTINGS_CONFIG.intervals.available.filter(item => item.enabled);
};

/**
 * ヘルパー関数：有効な判定ルールのリストを取得
 */
export const getAvailableRules = () => {
  return ALERT_SETTINGS_CONFIG.rules.available.filter(rule => rule.enabled);
};

/**
 * 曜日マッピング（日本語 → 英語）
 */
export const DAYS_MAP = {
  月: 'MON',
  火: 'TUE',
  水: 'WED',
  木: 'THU',
  金: 'FRI',
  土: 'SAT',
  日: 'SUN'
} as const;

export type DayKey = keyof typeof DAYS_MAP;
export type DayValue = (typeof DAYS_MAP)[DayKey];

/**
 * アクティブステータス定数
 */
export const ACTIVE_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0
} as const;

/**
 * 受信メール種別
 */
export const RECEIVE_MAIL_TYPE = {
  ABNORMAL_ONLY: 2,
  ALL: 1
} as const;

// 受信メール種別の型
export type ReceiveMailType = (typeof RECEIVE_MAIL_TYPE)[keyof typeof RECEIVE_MAIL_TYPE];

// 旧データ(0)を新定義(1)に正規化
export const normalizeReceiveMailType = (v: number): ReceiveMailType => {
  if (v === 0) return RECEIVE_MAIL_TYPE.ALL;
  return v as ReceiveMailType;
};

// UI 選択肢
export const RECEIVE_MAIL_OPTIONS: Array<{value: ReceiveMailType; label: string}> = [
  {value: RECEIVE_MAIL_TYPE.ALL, label: '毎回送信'},
  {value: RECEIVE_MAIL_TYPE.ABNORMAL_ONLY, label: '異常時のみ'}
];

/**
 * SQL ID定数
 */
export const SQL_IDS = {
  GET_ALERT_SETTINGS: 136
} as const;
